import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
@Component({
    selector: 'app-lotti-animation',
    standalone: true,
    imports: [
        CommonModule,
        LottieComponent
    ],
    templateUrl: './lottie-animation.component.html',
    styleUrls: []
})
export class AppLottieAnimationComponent implements OnInit {
    @Input({ required: true }) path: string;
    options: AnimationOptions;
    ngOnInit(): void {
        this.options = { path: this.path };
    }
}
